// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import {
    getRequestTypes,
    selectAllDealersOnInitialLoad,
    selectAllReturnStatusesOnInitialLoad,
    selectDefaultLoadRequestDates
} from '../../all-parts-requests/action-creators/facets';
import {
    loadAllAccounts,
    loadAllReturnStatuses,
    loadDefaultRequestDates
} from '../../shared/services/facets-services';
import actions from '../../actions-list';
import {buildPayload} from '../../shared/services/build-payload';
import {getPartReturns} from '../../shared/repositories';
import {readExcelLayouts} from '../../../shared/action-creators/read-excel-layouts';

const setAllPartRequestsFacets = (dispatch, getState) => {

    if (loadAllAccounts(getState().partReturns.allPartReturns.facets.dealerAccountsFacet)) {

        selectAllDealersOnInitialLoad(getState().user.details.settings.dealer.accounts.selectedAccounts)(dispatch);

    }

    if (loadAllReturnStatuses(getState().partReturns.allPartReturns.facets.partReturnStatusesFacet)) {

        selectAllReturnStatusesOnInitialLoad(getState().user.details.settings.partReturns.status.selectedStatuses)(dispatch);

    }

    if (loadDefaultRequestDates(getState().partReturns.allPartReturns.facets.requestDateFacet)) {

        selectDefaultLoadRequestDates(getState().user.details.settings.partReturns.numberOfDays)(dispatch);

    }

};

export const readOpenPartRequests = () =>

    async (dispatch, getState) => {

        setAllPartRequestsFacets(dispatch, getState);

        dispatch(busyCounter.increaseBusyCounter());

        const openPartRequestsPayload = buildPayload(getState().partReturns.openPartReturns.facets, '', '');

        try {

            const data = await getPartReturns(openPartRequestsPayload);

            dispatch({
                data,
                type: actions.READ_OPEN_PART_REQUESTS_SUCCESS
            });

            getRequestTypes()(dispatch, getState);

            if (!getState().exportToExcel.selectedExcelLayout.partRequests.name) {

                readExcelLayouts('partRequests')(dispatch);

            }

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/part-requests/open-parts-requests/action-creators/open-part-requests.js